module.exports = __webpack_public_path__ + "static/media/14-10.22a713e4.mp3";